<template>
  <div>
    <CustomCallout
      :has-toggle="true"
      class="mt-2 deep"
      :border-color-hex="value.color"
      :opened="open"
      :controlled="true"
      @click:open="openSection()"
    >
      <div class="row mt-2 pb-3">
        <div class="col-md-2 col-lg-2 pt-3">
          <div class="row d-flex justify-content-start">
            <div
              class="col-8 rounded-pill p-2 text-center"
              :style="{ backgroundColor: value.color }"
            >
              <span class="font-weight-bold">{{ value.status }}</span>
            </div>
            <div class="col-10">
              <span class="font-weight-bold">{{ value.number }}</span>
            </div>
          </div>
        </div>
        <div class="pt-3 border-left" :class="showCheckBoxChangeStatus ? 'col-md-7' : 'col-md-8'">
          <div class="row pl-3">
            <div class="col-md-4">
              <div class="info-text-title">Nombre del Estudiante:</div>
              <p>{{ !showByRequestType ? value.studentName : "-" }}</p>
            </div>
            <div class="col-md-4">
              <div class="info-text-title">Centro/Municipio:</div>
              <p>{{ value.center }}, {{ value.municipality }}</p>
            </div>
            <div class="col-md-4">
              <div class="info-text-title">Impedimento:</div>
              <p>{{ !showByRequestType ? value.impediment : "-" }}</p>
            </div>
            <div class="col-md-4">
              <div class="info-text-title">Escuela:</div>
              <p>{{ value.school }}</p>
            </div>
            <div class="col-md-4">
              <div class="info-text-title">Necesidad(es):</div>
              <p>{{ necesities(value.necesities) }}</p>
            </div>
            <div class="col-md-4">
              <div class="info-text-title">Tipo de Solicitud:</div>
              <p>{{ value.assistantType || "-" }}</p>
            </div>
          </div>
        </div>
        <div class="col-2 d-flex align-items-center">
          <Dropdown
            class="w-100 "
            name="Actions"
            title="Acciones"
            :items="availableActions"
          />
        </div>
         <div class="col-1 d-flex align-items-center border-left" v-if="showCheckBoxChangeStatus">
            <CheckBox
             v-model="value.selected"
              class="font-weight-light"
              :disabled="desableStatus"
              @input="onCheck(value)"
            />
          </div>
      </div>

      <template #edition>
        <CancelRequestGeneral
          v-if="showingCancel"
          @changeStatusRequest="changeStatus"
          @hideCancelComponent="hideCancel()"
        />
      </template>
    </CustomCallout>
    <div class="tab-container p-2" v-if="showInfo && open">
      <div class="white-container">
        <custom-tab
          content-class="mt-3"
          :default-active-tab="activeTab"
          :no-nav-style="true"
          class="custom-tab-font"
          nav-class="nav-vue-underline"
        >
          <custom-tab-item
            class="mt-2 mt-3"
            title="Información Adicional"
            active="true"
          >
            <div
              class="row ml-5 mr-5 mt-3 tab-container pt-3 pb-3 rounded"
              v-for="item in value.studentList"
              :key="item.id"
            >
              <div class="col-md-3 p-custom-region">
                <div class="info-text-title">Nombre del Estudiante:</div>
                <p>{{ item.studentName }}</p>
              </div>
              <div class="col-md-1">
                <div class="info-text-title">Edad:</div>
                <p>{{ item.studentAge }}</p>
              </div>
              <div class="col-md-2 p-custom-grade  ">
                <div class="info-text-title">Grado:</div>
                <p>{{ item.studentGrade }}</p>
              </div>
              <div class="col-md-3">
                <div class="info-text-title">Necesidad(es):</div>
                <p>{{ necesities(item.necesities) }}</p>
              </div>
              <div class="col-md-3 ">
                <div class="info-text-title">Impedimento:</div>
                <p>{{ item.impediment }}</p>
              </div>
            </div>
            <br />
          </custom-tab-item>
        </custom-tab>
      </div>
    </div>
    <WarningMessage v-if="isPendingAmendment">
      <span>Pendiente enmienda de PEI</span>
    </WarningMessage>
  </div>
</template>

<script>
import Dropdown from "dropdown";
import ActionButton from "ActionButton";
import CustomCallout from "custom-callout";
import CustomTextArea from "CustomTextArea";
import CustomDropDown from "custom-drop-down";
import {
  requestStatusCodes,
  requestStatusString
} from "@/utils/constants/hrrequest/requestStatusCodes";
import { AssignmentTypeEnum } from "@/modules/peiSAEE/assignment-type-enum.js";
import IconView from "icon-view";
import { CustomTab, CustomTabItem } from "custom-tabs";
import { getRequestReport } from "@/modules/human-resources/api";
import generalService from "@/services/pei/general";
import { getDeterminationLetterReport as _getDeterminationLetterReport } from "@/modules/human-resources/api";
import CancelRequestGeneral from "./components/CancelRequest.vue";
import WarningMessage from "./components/WarningMessage.vue";
import alert from "@/mixin/alert.mixin";
import { requestTypeCodesString } from "@/utils/constants/hrrequest/requestTypeCodes";
import academicYears from "@/utils/constants/academicYears";
import CheckBox from 'CheckBox';
import store from "@/store/index";

const KEY_CHECKBOX='CHECKBOXSTATUSSTORAGE'
export default {
  name: "IrregularNecesitiesResultRow",
  components: {
    Dropdown,
    ActionButton,
    CustomCallout,
    CustomDropDown,
    CancelRequestGeneral,
    WarningMessage,
    CustomTextArea,
    IconView,
    CustomTab,
    CustomTabItem,
    CheckBox
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      required: true
    },
    assistants: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      assistantSelected: null,
      cancelReason: null,
      open: false,
      showingCancel: false,
      showInfo: false
    };
  },
  computed: {
    showByRequestType() {
      return (
        this.value.assistantType == requestTypeCodesString.DosMasEstudiantes ||
        this.value.assistantType == requestTypeCodesString.Grupo
      );
    },
    canCancel() {
      const hasCancelPermission = this.$store.getters.HasPermission(
        "rrhh.serviceassistant.action.cancel"
      );
      return (
        hasCancelPermission &&
        this.value.statusId != requestStatusCodes.Cancelada
      );
    },
    canDownloadRpDocuments(){
      return this.value.statusId == requestStatusCodes.ApprovedProvisionalRemedy
      && this.value.assistantType == requestTypeCodesString.Estudiantes
    },
    availableActions() {
      return [
        {
          label: "Entrar",
          border: "bottom",
          icon: "fas fa-clipboard-check color-primary-1",
          click: () => this.goToRequestDetail(),
          visible: this.hasEnterPermission,
        },
        {
          label: "Información Adicional",
          icon: "fas fa-info-circle color-primary-1",
          click: () => this.showInfoSection()
        },
        {
          label: "Imprimir",
          icon: "fas fa-print color-primary-1",
          click: () => this.onPrintReport()
        },
        {
          visible: this.canShowChangeStatusToPrevious,
          label: "Regresar al estatus anterior",
          icon: "far fa-undo color-primary-1",
          click: () => this.changeRequestStatusToPrevious()
        },
        {
          label: 'Relacionar Solicitudes',
          visible: this.canShowRequestRelation,
          icon: "fas fa-link color-primary-1",
          click: () => {}
        },
        {
          label: "Historial de la Solicitud",
          icon: "fas fa-clock color-primary-1",
          click: () => this.goToHistory()
        },
        {
          label: "Cancelar Solicitud",
          icon: "fas fa-times-circle text-red",
          click: () => this.showCancel(),
          visible: this.canCancel
        },
        {
          label: "Descargar Solicitud",
          icon: "fas fa-print color-primary-1",
          click: () => this.downloadRpRequest(),
          visible: this.canDownloadRpDocuments
        },
        {
          label: "Descargar Carta de Aprobación",
          icon: "fas fa-print color-primary-1",
          click: () => this.downloadDeterminationLetter(),
          visible: this.canDownloadRpDocuments

        }

      ];
    },
    desableStatus(){
      return this.value.statusId == requestStatusCodes.Cancelada ||
       this.value.statusId == requestStatusCodes.recomended ||
       this.value.statusId == requestStatusCodes.notRecomended ||
       this.value.statusId == requestStatusCodes.NotRecommendedPEIAmendment;
    },
    isPendingAmendment() {
      return this.value.assigmentTypeId == AssignmentTypeEnum.PendingAmendment;
    },
    showCheckBoxChangeStatus(){
      return store.getters.HasPermission(
         "rrhh.changestatus.irregularperson"
      ) && this.value.academicYearId >= academicYears.Y2023_2024 ;
    },
    canShowChangeStatusToPrevious() {
      return (
        this.value.statusId != requestStatusCodes.new &&
        this.value.statusId != requestStatusCodes.Cancelada &&
        this.value.statusId != requestStatusCodes.PendienteDeAsignar &&
        this.$store.getters.HasPermission(
          "humanresources.irregularstaff.changestatustoprevious"
        )
      );
    },
    hasEnterPermission() {
      return this.$store.getters.HasPermission(
        "humanresources.irregularstaff.request.enter"
      );
    },
    canShowRequestRelation() {
      return (
        this.value.statusId == requestStatusCodes.SAEEAnalysisProcess &&
        this.$store.getters.HasPermission("humanresources.irregularstaff.request.relation")
      );
    }
  },
  methods: {
    async onCheck(value){
      this.$emit("listIds",value);
      this.savedCheckStatus(value)
    },
    savedCheckStatus(value){
      let dataToUpdate={
        requestId:value.id,
        checkValue:value.selected,
      }
      let checkStatusIds= sessionStorage.getItem(KEY_CHECKBOX)
          let idsParsed=JSON.parse(checkStatusIds);
          if(idsParsed.length==0){
            idsParsed.push(dataToUpdate)
          }else{
            var result = idsParsed.find(function(obj) {
              return obj.requestId == value.id;
            });
            if(result){
              result.checkValue=value.selected
            }else{
              idsParsed.push(dataToUpdate)
            }
          }
        checkStatusIds= sessionStorage.setItem( KEY_CHECKBOX, JSON.stringify(idsParsed));
    },
    openSection() {
      this.open = !this.open;
      if (this.open) {
        this.showInfoSection();
      }
    },
    necesities(str) {
      let wrd = str.split(", ");
      let uniqueWrd = wrd.filter(function(item, index) {
        return wrd.indexOf(item) === index;
      });
      return uniqueWrd.join(", ");
    },
    showCancel() {
      this.open = true;
      this.showingCancel = true;
      if (this.showInfo) {
        this.showInfo = false;
      }
    },
    async downloadRpRequest(){
      await generalService.downloadMipeReport(
         `rprequest/${this.value.studentList[0].provRemReqNumber}`
      );
    },
    async downloadDeterminationLetter() {
      await _getDeterminationLetterReport({
        requestServiceId: this.value.studentList[0].provRemRequestService.requestServiceId,
          serviceTypeId: this.value.studentList[0].provRemRequestService.serviceTypeId,
          serviceStatusId: this.value.studentList[0].provRemRequestService.serviceStatusId,
          determinationReasonId: this.value.studentList[0].provRemRequestService.determinationReasonId,
          determinationReasonCategoryId: this.value.studentList[0].provRemRequestService.determinationReasonCategoryId,
      })
        .then((res) => generalService.ConvertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    hideCancel() {
      this.open = false;
      this.showingCancel = false;
    },
    showInfoSection() {
      this.open = true;
      this.showInfo = true;
      if (this.showingCancel) {
        this.showingCancel = false;
      }
    },
    goToRequestDetail() {
      this.$emit("go-to-detail");

      const reRoutingPath = this.value.academicYearId >= academicYears.Y2023_2024 && this.value.statusId == 1?
      `/humanres/irregularstaffrequest/${this.value.id}`:
      `/humanres/irregularrequest/edit/${this.value.id}`;

      this.$router.push({ path: reRoutingPath });
    },
    async tryCancel() {
      const isValid = await this.$refs.cancelationForm.validate();
      if (!isValid) return;

      this.$emit("cancel", this.value.id, this.cancelReason);
      this.hideCancel();
    },
    async onPrintReport() {
      let self = this;
      await getRequestReport(false, this.value.id)
        .then(res => {
          self.report = res;
          generalService.documentDownloadReport(
            self.report.content,
            self.report.filename,
            self.report.contentType
          );
        })
        .catch(err => {
          alert(err);
        });
    },
    async changeStatus(val) {
      this.cancelReason = val;
      const info = {
        dto: {
          id: requestStatusCodes.Cancelada,
          description: requestStatusString[requestStatusCodes.Cancelada],
          reason: this.cancelReason ?? null
        },
        valueId: this.value.id
      };
      this.$emit("updateSearch", info);
    },

    async changeRequestStatusToPrevious() {
      const answer = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea regresar al estatus ${
          requestStatusString[this.value.previousStatusId]
        }?`
      );

      if (answer) {
        this.$emit("changeStatus", this.value.id);
      }
    },
    goToHistory() {
      this.$router.push(`/humanres/request/history/${this.value.id}`);
    }
  },

  watch: {
    open(newValue) {
      if (!newValue) this.showingCancel = false;
    },
    value: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
       let checkStatusIds= sessionStorage.getItem(KEY_CHECKBOX)
       let idsParsed=JSON.parse(checkStatusIds);
       let result = idsParsed.find(function(obj) {
          return obj.requestId == newValue.id;
        });
        if(result){
          this.value.selected=result.checkValue
        }
        this.$emit("listIds",newValue);
        if (oldValue) return;

        const hasAssistant =
          newValue.assigmentTypeId == AssignmentTypeEnum.Assistant;
        this.assistantSelected = this.assistants.find(x =>
          x.isAssistant == hasAssistant && hasAssistant
            ? x.key == newValue.assistantId
            : x.key == newValue.assigmentTypeId
        );
      }
    },
    assistantSelected: {
      deep: true,
      handler(newValue) {
        if (!newValue) return;

        if (newValue.isAssistant) {
          this.$emit("assign-assistant", this.value.id, newValue.key);
          return;
        }

        const isPendingAmendment =
          !newValue.isAssistant &&
          newValue.key == AssignmentTypeEnum.PendingAmendment;
        if (isPendingAmendment) this.$emit("pending-amendment", this.value.id);

        const isVacantPosition =
          !newValue.isAssistant &&
          newValue.key == AssignmentTypeEnum.VacantPosition;
        if (isVacantPosition) this.$emit("vacant-position", this.value.id);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tab__container {
  padding: 20px 30px;
}

.action-buttons__container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
}

.dot-icon__container {
  padding: 3px 5px;
  border-radius: 50%;
  box-shadow: 0 3px 6px #00000029;
  background: #fff 0 0 no-repeat padding-box;
}

::v-deep .custom-text-area__container textarea {
  min-height: 50px !important;
}

.info-text-title {
  color: #727272;
  font-size: 16px;
  font-weight: normal;
}
.white-container {
  background-color: white;
  border-radius: 5px;
}
.tab-container {
  background-color: #f7f7f7;
}
.custom-tab-font {
  --tab-font-size: 16px !important;
}
.p-custom {
  padding-left: 14rem !important;
}
.p-custom-grade {
  padding-left: 6rem !important;
}
.p-custom-region {
  padding-left: 7rem !important;
}
</style>
